<template>
  <div class="text-nowrap text-center">
    <span class="align-text-top text-capitalize">
      {{ value ? value.fullName : "-" }}
    </span>
    <br>
  </div>
</template>

<script>
export default {
  name: 'WriterCell',
  props: ['value'],

}
</script>
